import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ManageAcceleratorComponent} from '../accelerators/manage-accelerator/manage-accelerator.component';
import {AlertDatabaseInputComponent, CreateAlertComponent} from './create-alert/create-alert.component';
import {environment} from '../../environments/environment';
import {ConfService} from '../conf.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {interval} from 'rxjs';
import {AlertService} from '../alert.service';
import {ListenerService} from '../listener.service';

@Component({
  selector: 'app-alert-settings',
  templateUrl: './alert-settings.component.html',
  styleUrls: ['./alert-settings.component.scss']
})
export class AlertSettingsComponent implements OnInit {

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  componentLoading = true;
  alertsData: any;

  hasAddPermission = false;
  hasViewPermission = false;

  isEntityFound = false;

  constructor(public dialog: MatDialog,
              private cfgSrv: ConfService,
              public alertService: AlertService,
              private leftPanelDataListener: ListenerService,
              public platform: LeftpanelComponent) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    const permissionSubscription = interval(500).subscribe((async x => {
        permissionSubscription.unsubscribe();

        this.hasAddPermission = this.platform.hasPlatformPermission('ADD_ALERTS');
        this.hasViewPermission = this.platform.hasPlatformPermission('VIEW_ALERTS');
        if (this.hasViewPermission) {
          this.initializeData();
        } else {
          this.componentLoading = false;
        }
    }));
  }

  initializeData() {

    const payload = {
      partner: this.partner,
      account: this.account,
      significance: 'compose',
      intent: 'alerts'
    };
    this.componentLoading = true;
    this.cfgSrv.postCoreApi(environment.coreAPI.alertConfig.name, environment.coreAPI.alertConfig.version, payload).subscribe(data => {
      let res: any;
      res = data;
      this.alertsData = res['items'];
      this.componentLoading = false;
      this.isEntityFound = true;

    }, error => {
      if (error.status === 422) {
        this.componentLoading = false;
        this.isEntityFound = false;
      } else {
        this.platform.handleErrorGracefully(error, 'Error while fetching alerts.');
      }

    });
  }

  setupAlertsManager() {
    const databaseDialog = this.dialog.open(AlertDatabaseInputComponent, {
      width: '450px',
      maxHeight: 'auto',
      data: {
        message: 'Alerts manager is being setup. This can take up to a few minutes'
      }
    });

    databaseDialog.afterClosed().subscribe(response => {
      if (response) {
        if (response.database) {
          this.setupDaasForAlerts(response.database);
        }
      }
    });
  }

  setupDaasForAlerts(database) {
    const loader = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
      data: {
        message: 'Alerts manager is being setup. This can take up to a few minutes'
      }
    });

    const payload = {
      partner: this.partner,
      account: this.account,
      database: database
    };

    this.cfgSrv.postCoreApi(environment.coreAPI.alertsManager.name, environment.coreAPI.alertsManager.version, payload).subscribe(data => {
      let res: any;
      res = data;
      this.componentLoading = false;
      this.isEntityFound = true;
      loader.close();
      this.initializeData();
      this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');


    }, error => {
      this.isEntityFound = false;
      loader.close();
      this.platform.handleErrorGracefully(error, 'Error while setting up Alerts manager');
    });
  }


  createAlert() {
    const dialogRef = this.dialog.open(CreateAlertComponent, {
      height: 'auto',
      width: '60%',
      data: {
        'partner': this.partner,
        'account': this.account
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.initializeData();
        this.alertService.alertRefreshListener.emit({action: 'subscription'});
      }
    });
  }

  editAlert(alert) {
    const dialogRef = this.dialog.open(CreateAlertComponent, {
      height: 'auto',
      width: '60%',
      data: {
        'partner': this.partner,
        'account': this.account,
        isEdit: true,
        topicName: alert.topic_name,
        description: alert.description
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        this.initializeData();
        this.alertService.alertRefreshListener.emit({action: 'init'});
      }
    });
  }

  deleteAlert(alert) {
    if (confirm('This action is irreversible. Do you still want to delete ' + alert.topic_name + ' ?')) {
      const payload = {
        partner: this.partner,
        account: this.account,
        significance: 'eliminate',
        intent: 'alert',
        data: {topic: alert.topic_name}
      };

      this.cfgSrv.postCoreApi(environment.coreAPI.alertConfig.name, environment.coreAPI.alertConfig.version, payload).subscribe(data => {
        let res: any;
        res = data;
        this.platform.openSnackBar(alert.topic_name + ' deleted successfully.', 'Success', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.initializeData();
      }, error => {
        this.platform.handleErrorGracefully(error, 'Error while deleting alert. Please try again later');
      });
    }
  }

}
